<template>
    <div>
        <input type="checkbox"
               class="custom-control-input custom-control-input-red"
               v-model="dataOptionValue"
               :disabled="adjustmentsFieldsDisabled"
               :value="optionKey"
               :id="optionKey"/>

        <label :for="optionKey"
               :class="adjustmentsFieldsDisabled ?'border-warning':'' "
               class="custom-control-label pl-2">
            {{ title }}
        </label>

        <popper
            v-if="popoverText"
            :options="{
                placement: 'top'
            }"
        >
            <div class="popper">
                {{popoverText}}
            </div>

            <i class="fas fa-info-circle pl-2 pt-1 text-info" slot="reference">
            </i>
        </popper>

    </div>

</template>

<script>


    import Popper from 'vue-popperjs';
    import 'vue-popperjs/dist/vue-popper.css';
export default {
    components: {
        'popper': Popper
    },
    props: {
        adjustmentsFieldsDisabled: Boolean,
        optionKey: String,
        title: String,
        popoverText: String,
        optionValue : Boolean,
        parent: String
    },
    data() {
        return {
            dataOptionValue : this.optionValue
        };
    },
    watch: {
        dataOptionValue: function (value) {
            this.$emit('updateOption', {'parent': this.parent, 'value': this.optionKey, 'checked': this.dataOptionValue});
        },
    methods: {
        }
    }

}
</script>

